




































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateAgencyGroupRequest from '@/models/AgencyGroups/CreateAgencyGroupRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';

@Component({
    name: 'AgencyGroupCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateAgencyGroupRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateAgencyGroupRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get users() {
    return AgencySettingsModule.agencyUsers.filter(function(agencyUser){
      if (agencyUser.status === AgencyUserStatus.Active ) {
        return true;
      }
      return false;
    })
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
       
    await AgencySettingsModule.createAgencyGroup(this.entity)
    this.dialog = false;
  }
}
